<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="deleting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Deleting, please wait
        </div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="exporting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Exporting, please wait
        </div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex justify-between">
        <div class="flex-2xs pr-3">
          <div class="pr-3-2xs pb-2 pb-0-2xs">
            <div class="input-group">
              <div class="input-group-addon" style="width: 60px;">From:</div>
              <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
            </div>
          </div>
          <div class="pr-3-2xs pb-2 pb-0-2xs">
            <div class="input-group">
              <div class="input-group-addon" style="width: 60px;">To:</div>
              <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
            </div>
          </div>
          <div class="pr-3-2xs pb-2 pb-0-2xs" v-if="view_mode === 'companies'">
            <input type="text" placeholder="Search" class="form-control" v-model="search_query">
          </div>
        </div>
        <div class="flex justify-end" v-if="logged_in_user.isStaff">
          <div class="flex">
            <div v-if="view_mode === 'leads'" class="ml-1">
              <a class="btn-primary-outline" @click="view_mode = 'companies'">
                Switch View: Companies
              </a>
            </div>
            <div v-if="view_mode === 'companies'" class="ml-1">
              <a class="btn-primary-outline" @click="view_mode = 'leads'">
                Switch View: Leads
              </a>
            </div>
            <div v-if="view_mode === 'companies'" class="ml-1">
              <a class="btn-primary-outline" @click="exportLeadCounts()">
                Export
              </a>
            </div>
            <div v-if="view_mode === 'leads'" class="ml-1">
              <a class="btn-primary-outline" @click="exportLeads()">
                Export
              </a>
            </div>
            <div class="ml-1">
              <a class="btn-primary" href="/leads/create">
                New&nbsp;Lead
              </a>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!loading && total_count > 0">
        <div class="mt-3" v-if="view_mode === 'leads'">
          <table class="table_leads-list">
            <thead>
            <tr>
              <th>
                Date
              </th>
              <th>
                System
              </th>
              <th>
                Type
              </th>
              <th>
                Contact Email
              </th>
              <th v-if="logged_in_user.isStaff">
                Assigned to
              </th>
              <th v-if="logged_in_user.isStaff"></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(lead, index) in leads">
              <td>
                {{ lead.formatted_created_at }}
              </td>
              <td>
                <span v-if="lead.epwin_system_type !== null"> {{ lead.epwin_system_type.label }} </span>
                <span v-else>N/A</span>
              </td>
              <td>
                {{ lead.type }}
              </td>
              <td>
                {{ lead.email }}
              </td>
              <td v-if="logged_in_user.isStaff">
              <span v-if="lead.companies.length > 0"> {{ lead.companies.length }} <template
                  v-if="lead.companies.length > 1"> Companies</template><template v-else> Company </template> </span>
                <span v-else>None</span>
              </td>
              <td class="td_delete-lead" v-if="logged_in_user.isStaff">
                <a @click="deleteLead(lead.id)" class="txt-danger">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
              <td class="td_view-lead">
                <a :href='"/leads/"+lead.id' class="txt-primary">
                  <i class="fa fa-eye"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="view_mode === 'companies'" class="mt-3">
          <table class="table_leads-assign-to-list">
            <thead>
            <tr>
              <th>
                Company
              </th>
              <th style="width: 87px; text-align: center;">
                Assigned
              </th>
              <th style="width: 87px; text-align: center;">
                Accepted
              </th>
              <th style="width: 87px; text-align: center;">
                Rejected
              </th>
              <th style="width: 87px; text-align: center;">
                Won
              </th>
              <th style="width: 87px; text-align: center;">
                Lost
              </th>
              <th style="width: 87px; text-align: center;">
                Quoted
              </th>
              <th style="width: 87px; text-align: center;">
                Total
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(company, index) in leads">
              <tr>
                <td>
                  {{ company.name }}
                </td>
                <td class="align-center" :class="{'muted' : company.assigned_leads.length === 0}">
                  {{ company.assigned_leads.length }}
                </td>
                <td class="align-center" :class="{'muted' : company.accepted_leads.length === 0}">
                  {{ company.accepted_leads.length }}
                </td>
                <td class="align-center" :class="{'muted' : company.rejected_leads.length === 0}">
                  {{ company.rejected_leads.length }}
                </td>
                <td class="align-center" :class="{'muted' : company.won_leads.length === 0}">
                  {{ company.won_leads.length }}
                </td>
                <td class="align-center" :class="{'muted' : company.lost_leads.length === 0}">
                  {{ company.lost_leads.length }}
                </td>
                <td class="align-center" :class="{'muted' : company.quoted_leads.length === 0}">
                  {{ company.quoted_leads.length }}
                </td>
                <td class="align-center" :class="{'muted' : company.leads.length === 0}">
                  {{ company.leads.length }}
                </td>
                <td class="th_open-user-list">
                  <label class="cursor-pointer">
                    <input type="checkbox" class="hide" v-model="company_list_open" :value="company.id">
                    <i class="fal fa-chevron-down" v-show="!isOpen(company.id)"></i>
                    <i class="fal fa-chevron-up" v-show="isOpen(company.id)"></i>
                  </label>
                </td>
              </tr>
              <tr v-show="isOpen(company.id)">
                <td colspan="9">
                  <table class="table_leads-list txt-sm">
                    <thead>
                    <tr>
                      <th>
                        Date
                      </th>
                      <th>
                        System
                      </th>
                      <th>
                        Type
                      </th>
                      <th>
                        Contact Email
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(lead, index) in company.leads">
                      <td>
                        {{ lead.formatted_created_at }}
                      </td>
                      <td>
                        <span v-if="lead.epwin_system_type !== null"> {{ lead.epwin_system_type.label }} </span>
                        <span v-else>N/A</span>
                      </td>
                      <td>
                        {{ lead.type }}
                      </td>
                      <td>
                        {{ lead.email }}
                      </td>
                      <td class="td_status">
                        <select class="form-control _sm" v-model="lead.pivot.lead_status_id" @change="updateStatus($event, company.id, lead.id)">
                          <option v-for="status in statuses"
                                  :value="status.id"
                                  :disabled="
                                  lead.pivot.lead_status_id === 1 ||
                                  status.id === 1 ||
                                  lead.pivot.lead_status_id < 3 && status.id === 2"
                                  v-show="!logged_in_user.isStaff && status.id > 1 || logged_in_user.isStaff">
                            {{ status.label }}
                          </option>
                        </select>
                        <div class="mt-1" v-if="lead.pivot.status_updated_by_name !== null">
                          Updated By: {{ lead.pivot.status_updated_by_name }} - {{ lead.pivot.status_updated_at_formatted }}
                        </div>
                      </td>
                      <td class="td_view-lead">
                        <a :href='"/leads/"+lead.id' class="txt-primary">
                          <i class="fa fa-eye"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong class="block mt-6">
          No Results Found
        </strong>
      </template>
    </div>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';

export default {
  props: [
    'logged_in_user',
    'statuses',
  ],
  components: {
    'datepicker': Datepicker,
  },
  mounted() {
    this.loadLeads();
  },
  data() {
    return {
      view_mode: 'leads',
      leads: [],
      current_page: 1,
      date_filter_start: null,
      date_filter_end: new Date(),
      total_count: 0,
      total_pages: 0,
      limit: 20,
      loading: true,
      deleting: false,
      company_list_open: [],
      search_query: '',
      exporting: false,
    }
  },
  methods: {
    loadLeads: _.debounce(function () {
      if(this.view_mode === 'companies') {
        axios.post('/leads/loadLeadsCompanyViewData', {
          page_number: this.current_page,
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
          search_query: this.search_query,
          limit: this.limit,
        }).then((response) => {
          this.leads = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
          this.loading = false;
        });
      } else {
        axios.post('/leads/loadLeads', {
          page_number: this.current_page,
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
          search_query: this.search_query,
          limit: this.limit,
        }).then((response) => {
          this.leads = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
          this.loading = false;
        });
      }
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.loadLeads();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.loadLeads();
    },
    deleteLead(lead_id) {
      Swal.fire({
        title: 'Are you sure you want to remove this lead?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleting = true;
          axios.post('/leads/deleteLead', {
            lead_id: lead_id,
          }).then((response) => {
            this.deleting = false;
            this.loadLeads();
            Swal.fire({
              'title': 'Lead Deleted',
              'icon': 'success',
            });
          });
        }
      });
    },
    updateStatus(event, company_id, lead_id) {
      axios.post('/leads/updateStatus',{
        lead_id: lead_id,
        status_id: event.target.value,
        company_id: company_id,
      }).then((response) => {

        this.loading = true;
        this.current_page = 1;
        this.loadLeads();

        Swal.fire({
          title: 'Status Updated',
          icon: 'success',
          html: '',
        });
      });
    },
    exportLeads() {
      axios.post('/leads/exportLeads', {
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        search_query: this.search_query,
        view_mode: this.view_mode,
      }, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'leads.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exporting = false;
      });
    },
    exportLeadCounts() {
      axios.post('/leads/exportLeadCounts', {
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        search_query: this.search_query,
        view_mode: this.view_mode,
      }, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lead_counts.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exporting = false;
      });
    },
    isOpen(id) {
      return this.company_list_open.includes(id);
    },
  },
  watch: {
    date_filter_start() {
      this.loading = true;
      this.current_page = 1;
      this.loadLeads();
    },
    date_filter_end() {
      this.loading = true;
      this.current_page = 1;
      this.loadLeads();
    },
    view_mode() {
      this.loading = true;
      this.current_page = 1;
      this.loadLeads();
    },
    search_query() {
      this.loading = true;
      this.current_page = 1;
      this.loadLeads();
    },
  },
};
</script>

<style scoped>
.muted {
  opacity: 0.4;
}
</style>